import {
  ADD_DECISION_TYPE_ATTACHMENT,
  ADD_DECISION_TYPE_ATTACHMENT_START,
  ADD_DECISION_TYPE_ATTACHMENT_ERROR,
  GET_DECISION_TYPE_ATTACHMENT,
  GET_DECISION_TYPE_ATTACHMENT_START,
  GET_DECISION_TYPE_ATTACHMENT_ERROR,
  GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW,
  GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_START,
  GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR,
  GET_DECISION_TYPE_ATTACHMENT_LIST,
  GET_DECISION_TYPE_ATTACHMENT_LIST_ERROR,
  GET_DECISION_TYPE_ATTACHMENT_LIST_START,
  GET_DECISION_TYPE_ATTACHMENT_LIST_PAGEABLE,
  REMOVE_ATTACHMENT,
  CLEAR_ERROR_DECISION_TYPE_ATTACHMENT,
} from '../actions/types';

const initialState = {
  decisionAttachment: {},
  loading: false,
  error: undefined,
  attachmentContent: [],
  decisionAttachmentList: [],
  totalElements: '',
};

const clearError = (state) => {
  return {
    ...state,
    error: undefined,
    attachmentContent: [],
  };
};

const addDecisionAttachmentStart = (state) => {
  return {
    ...state,
  };
};

const addDecisionAttachment = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionAttachment: action.payload,
  };
};

const addDecisionAttachmentError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findDecisionAttachmentByDecisionStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findDecisionAttachmentByDecision = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionAttachment: action.payload,
  };
};

const findDecisionAttachmentByDecisionError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findDecisionAttachmentByDecisionNameStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findDecisionAttachmentByDecisionName = (state, action) => {
  return {
    ...state,
    loading: false,
    attachmentContent: action.payload,
  };
};

const findDecisionAttachmentByDecisionNameError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const removeAttachment = (state) => {
  return {
    ...state,
    attachmentContent: [],
  };
};

const findAllDecisionAttachmentStart = (state) => {
  return {
    ...state,
    loading: true,
  };
};

const findAllDecisionAttachment = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionAttachmentList: action.payload,
  };
};

const findAllDecisionAttachmentError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllDecisionAttachmentPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    decisionAttachmentList: action.payload[0],
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_DECISION_TYPE_ATTACHMENT:
      return addDecisionAttachment(state, action);
    case ADD_DECISION_TYPE_ATTACHMENT_START:
      return addDecisionAttachmentStart(state);
    case ADD_DECISION_TYPE_ATTACHMENT_ERROR:
      return addDecisionAttachmentError(state, action);

    case GET_DECISION_TYPE_ATTACHMENT:
      return findDecisionAttachmentByDecision(state, action);
    case GET_DECISION_TYPE_ATTACHMENT_START:
      return findDecisionAttachmentByDecisionStart(state);
    case GET_DECISION_TYPE_ATTACHMENT_ERROR:
      return findDecisionAttachmentByDecisionError(state, action);

    case GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW:
      return findDecisionAttachmentByDecisionName(state, action);
    case GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_START:
      return findDecisionAttachmentByDecisionNameStart(state);
    case GET_DECISION_TYPE_ATTACHMENT_CONTENT_FOR_PREVIEW_ERROR:
      return findDecisionAttachmentByDecisionNameError(state, action);

    case REMOVE_ATTACHMENT:
      return removeAttachment(state);

    case CLEAR_ERROR_DECISION_TYPE_ATTACHMENT:
      return clearError(state);

    case GET_DECISION_TYPE_ATTACHMENT_LIST:
      return findAllDecisionAttachment(state, action);
    case GET_DECISION_TYPE_ATTACHMENT_LIST_START:
      return findAllDecisionAttachmentStart(state);
    case GET_DECISION_TYPE_ATTACHMENT_LIST_ERROR:
      return findAllDecisionAttachmentError(state, action);

    case GET_DECISION_TYPE_ATTACHMENT_LIST_PAGEABLE:
      return findAllDecisionAttachmentPageable(state, action);

    default:
      return state;
  }
}
